/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Directory_Tools_Generators_DescriptionInputs */

const en_directory_tools_generators_description = /** @type {(inputs: Directory_Tools_Generators_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Built and run by ${i?.app}. Pay per video with one-time credits; failed renders are refunded.`)
};

const zh_directory_tools_generators_description = /** @type {(inputs: Directory_Tools_Generators_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由 ${i?.app} 自建并运行。用一次性积分按条付费，生成失败自动退还。`)
};

/**
* | output |
* | --- |
* | "Built and run by {app}. Pay per video with one-time credits; failed renders are refunded." |
*
* @param {Directory_Tools_Generators_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_generators_description = /** @type {((inputs: Directory_Tools_Generators_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Generators_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_generators_description(inputs)
	return zh_directory_tools_generators_description(inputs)
});
export { directory_tools_generators_description as "directory.tools.generators_description" }